import { BaseReportHelpers } from './BaseReportHelpers';
import { GeneralReportStore } from 'Reports';
import { toJS } from 'mobx';
import { ParameterHelper } from 'MeasurementsCalculations';
import { IReportMeasurement, IReportMeasurementGroup } from 'Data';

export abstract class MultiShotHelpers extends BaseReportHelpers {
  static onSelectStroke(
    group: IReportMeasurementGroup,
    stroke: IReportMeasurement,
    generalReportStore: GeneralReportStore
  ) {
    if (!generalReportStore.selectedStroke || generalReportStore.selectedStroke.id !== stroke.id) {
      generalReportStore.clubType = stroke.club ?? '';
      generalReportStore.selectedStroke = stroke;
      generalReportStore.selectedGroupOfStrokes = group;
      generalReportStore.selectedAverage = undefined;
    } else {
      generalReportStore.clubType = '';
      generalReportStore.selectedStroke = undefined;
      generalReportStore.selectedGroupOfStrokes = undefined;
    }
  }

  static selectAverage(
    strokes: Array<IReportMeasurement>,
    measurementGroup: IReportMeasurementGroup,
    reportStore: GeneralReportStore
  ) {
    if (
      reportStore.selectedAverage &&
      reportStore.selectedGroupOfStrokes &&
      measurementGroup.id === reportStore.selectedGroupOfStrokes.id
    ) {
      reportStore.selectedAverage = undefined;
      reportStore.selectedGroupOfStrokes = undefined;
      reportStore.clubType = '';
    } else {
      if (strokes?.length > 0) {
        reportStore.selectedStroke = undefined;
        reportStore.clubType = measurementGroup.clubType;
        const avg = toJS(strokes[0]);
        avg.id = MultiShotHelpers.NewGuid();

        for (let i = 0; i < reportStore.measurementParameters.length; i++) {
          (avg as any)[
            ParameterHelper.firstLetterToLowerCase(
              reportStore.measurementParameters[i].propertyName
            )
          ] = ParameterHelper.getComputedParameterAverage(
            strokes,
            reportStore.measurementParameters[i].propertyName,
            reportStore.unitPresentation,
            true
          );
        }

        reportStore.selectedAverage = avg;
        reportStore.selectedGroupOfStrokes = measurementGroup; // this must be last line to avoid infinite loop
      }
    }
  }

  static cleanSelectedShot(generalReportStore: GeneralReportStore) {
    generalReportStore.clubType = '';
    generalReportStore.selectedStroke = undefined;
    generalReportStore.selectedAverage = undefined;
    generalReportStore.selectedGroupOfStrokes = undefined;
  }

  static selectShot(
    stroke: IReportMeasurement,
    measurementGroup: IReportMeasurementGroup,
    reportStore: GeneralReportStore
  ) {
    if (reportStore.selectedStroke && stroke.id === reportStore.selectedStroke.id) {
      MultiShotHelpers.cleanSelectedShot(reportStore);
    } else {
      reportStore.clubType = stroke.club ?? '';
      reportStore.selectedAverage = undefined;
      reportStore.selectedStroke = stroke;
      reportStore.selectedGroupOfStrokes = measurementGroup;
    }
  }
  static onCleanSelectedShot(reportStore: GeneralReportStore) {
    reportStore.clubType = '';
    reportStore.selectedStroke = undefined;
    reportStore.selectedGroupOfStrokes = undefined;
  }
}
